import { AxiosInstance } from 'axios';
import { TSBApiResponse } from 'src/@type/common';
import { SignupFastRequest, SignupFastResponse } from './type';

export default (axios: AxiosInstance, apiPrefix: string) => ({
  signupFast(payload: SignupFastRequest): TSBApiResponse<SignupFastResponse> {
    return axios.post(`${apiPrefix}/auth/signup/fast`, payload);
  },
});
